import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromApiKey from './reducers/api-key.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ApiKeyEffects } from './effects/api-key.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('apiKey', fromApiKey.reducer),
    StoreModule.forFeature('apiKeyUsage', fromApiKey.getApiKeyUsageReducer),
    EffectsModule.forFeature([ApiKeyEffects])
  ]
})
export class ApiKeyModule { }
